import React from 'react'
import {Alert} from 'antd'
import logoInviso from 'assets/logo.svg'

import Form from './Form'
import './index.css'

class Login extends React.Component {
  render() {
    const {error, signInByCredentials} = this.props

    return (
      <div className="login">
        <div className="logo">
          <img src={logoInviso} alt="EFKT" />
        </div>

        {error &&
          <Alert type="error" message={error} />
        }

        <Form onSubmit={signInByCredentials} />
      </div>
    )
  }
}

export default Login
